// import { downloadHeight } from "client/config/memeGeneratorConfigs";
// import { getDownloadRatio } from "store/features/memeGenerator/utils/download/getDownloadRatio";
import { useAppSelector } from "store/store";
import { useMemeEditor } from "../../MemeEditorContext";

export const usePreviewContent = () => {
    const settings = useAppSelector((state) => state.memeGenerator.meme?.settings);
    const template = useAppSelector((state) => state.memeGenerator.meme?.template);
    const { shadowItemsContainerRef } = useMemeEditor();

    if (!settings || !template) return null;
    // const { xRatio, yRatio } = getDownloadRatio(settings.itemsContainer, downloadHeight);
    const xRatio = 1;
    const yRatio = 1;
    const calculatedSettings: typeof settings = {
        image: {
            left: settings.image.left * xRatio,
            top: settings.image.top * yRatio,
            width: settings.image.width * xRatio,
            height: settings.image.height * yRatio,
        },
        itemsContainer: {
            left: 0,
            top: 0,
            width: settings.itemsContainer.width * xRatio,
            height: settings.itemsContainer.height * yRatio,
        },
        parentContainerInitial: settings.parentContainerInitial,
    };

    return {
        calculatedSettings,
        shadowItemsContainerRef,
        template,
        xRatio,
        yRatio,
    };
};
